export default __webpack_public_path__ + "static/news-8ecd0b79f56748064286cc035da9d29b.png";